<form
  class="form"
  [formGroup]="reactiveFormObject"
  (keydown.enter)="formEnterClicked($event)">

  <mat-form-field appearance="fill" class="position-relative search-input">
    <mat-label>{{'Vehicle inventory number' | translate}}</mat-label>

    <input
      matInput
      type="search"
      formControlName="searchQuery"
      (keydown.enter)="preventDefault($event)">

      <!-- searching inactive -->
      @if (!searchQueryString) {
        <div class="input-feedback-icon">
          <mat-icon>search</mat-icon>
        </div>
      } @else {
        <!-- success/fail or loading -->
        @if (isSearchingVehicle) {
          <div class="input-feedback-icon spinner">
            <places-spinner small="true"></places-spinner>
          </div>
        } @else {
          <!-- success or fail -->
          @if (searchHitItem) {
            <div class="input-feedback-icon">
              <mat-icon>check</mat-icon>
            </div>
          } @else {
            <div class="input-feedback-icon error">
              <i class="icon fas fa-not-equal"></i>
            </div>
          }
        }
      }

      <!-- searching active -->
    </mat-form-field>

    <div class="d-flex">
      <div class="flex-grow-1 mw-50">
        <mat-form-field appearance="fill">
          <mat-label>{{'Start date' | translate}}</mat-label>
          <input matInput formControlName="startDate" type="date" [min]="minDate" [max]="maxDate">
        </mat-form-field>
      </div>
      <div class="flex-grow-1 mw-50">
        <mat-form-field appearance="fill">
          <mat-label>{{'Start time' | translate}}</mat-label>
          <input matInput formControlName="startTime" type="time">
        </mat-form-field>
      </div>
    </div>

    <div class="d-flex">
      <div class="flex-grow-1 mw-50">
        <mat-form-field appearance="fill">
          <mat-label>{{'End date' | translate}}</mat-label>
          <input matInput formControlName="endDate" type="date" [min]="minDate" [max]="maxDate">
        </mat-form-field>
      </div>
      <div class="flex-grow-1 mw-50">
        <mat-form-field appearance="fill">
          <mat-label>{{'End time' | translate}}</mat-label>
          <input matInput formControlName="endTime" type="time">
        </mat-form-field>
      </div>
    </div>

    <!-- Validation messages -->
    <div class="m-2 mb-4">
      @if (!searchHitItem
        && !isSearchingVehicle
        && (reactiveFormObject.controls['searchQuery'].dirty
        || reactiveFormObject.controls['searchQuery'].touched)) {
        <app-feedback-text type="error"
          >
          <div class="d-flex flex-column">
            <span translate>The search is invalid:</span>
            <span translate>No vehicle was found with the inventory number</span>
          </div>
        </app-feedback-text>
      }

      @if (showPropValidationMessage('startDate', 'futureDate')) {
        <app-feedback-text type="error">
          {{'Start date has to be in the past' | translate}}
        </app-feedback-text>
      }

      <!-- validation for the form/combined field properties (not one specific field property) -->
      @if (showFormValidationMessage('invalidTimeOrder')) {
        <app-feedback-text type="error">
          {{ 'Start time has to come before end time' | translate }}
        </app-feedback-text>
      }

      @if (showFormValidationMessage('invalidFutureDateTime')) {
        <app-feedback-text type="error">
          {{ 'End time has to be in the past' | translate }}
        </app-feedback-text>
      }

      @if (showFormValidationMessage('invalidTimeDiff')) {
        <app-feedback-text type="error">
          {{ 'The time between start and end has to be less than 24 hours' | translate }}
        </app-feedback-text>
      }

      @if (showPropValidationMessage('startDate', 'tooOldDate') || showPropValidationMessage('endDate', 'tooOldDate')) {
        <app-feedback-text type="error">
          {{'Date cannot be older than 89 days from today' | translate}}
        </app-feedback-text>
      }
    </div>

    <div class="d-flex">
      <button
        mat-flat-button
        class="secondary-button ml-3"
        (click)="reset($event)">{{ 'Clear' | translate }}
      </button>
      <button
        mat-flat-button
        class="primary-button ml-3"
        (click)="searchVehiclePositionHistory()"
        [disabled]="!reactiveFormObject.valid || !searchHitItem || isFetchingHistory" >
        {{ 'Search' | translate }}
        @if (isFetchingHistory) {
          <mat-icon class="ml-2"><mat-spinner diameter="20"></mat-spinner></mat-icon>
        }
      </button>
    </div>

    <div class="pt-2">
      @if (isHistoryDataIncomplete) {
        <app-feedback-text type="empty">
          {{'Could not find any history data for the vehicle in the time span' | translate}}
        </app-feedback-text>
      }
      @if (isHistoryDataIncomplete) {
        <app-feedback-text type="information">
          {{'Try another query' | translate}}.
        </app-feedback-text>
      }
    </div>

  </form>
